// src/components/Footer.jsx
import React from 'react';
import { Box, Typography, Link } from '@mui/material';

export default function Footer() {
  return (
    <Box
      component="footer"
      sx={{
        mt: 'auto',
        py: 2,
        px: 3,
        backgroundColor: '#f1f1f1',
        textAlign: 'center',
        borderTop: '1px solid #ddd',
      }}
    >
      <Typography variant="body2" color="textSecondary">
        © 2025 TvojaFirma. All rights reserved. |{' '}
        <Link href="mailto:kontakt@tvojafirma.com">kontakt@tvojafirma.com</Link> |{' '}
        <Link href="/privacy-policy">Privacy Policy</Link>
      </Typography>
    </Box>
  );
}
